<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-card class="mx-auto" max-width="400">
				<v-card-subtitle class="pt-4 text-center blue--text">
					میزان اعتبار کیف پول شما: {{ userCredit.toString().toPriceFormat() }} تومان
				</v-card-subtitle>
				<v-spacer />
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-text-money class="align-center" v-model="amount" label="مبلغ مورد نظر جهت شارژ (تومان):" :error-messages="errorMessages" :rules="[() => amount >= 100000 || 'حداقل مبلغ شارژ رعایت نشده است']" required />
							<small>حداقل مبلغ شارژ 100 هزار تومان می باشد</small>
						</v-col>
					</v-row>

				</v-card-text>

				<v-card-actions class="d-flex flex-column justify-center">
					<v-btn color="orange" class="mb-2" type="submit" :loading="submitLoading">
						هدایت به درگاه جهت واریز
					</v-btn>

					<v-btn v-if="['admin', 'agent'].includes(area)" color="orange" text @click="sendChargeWalletSms()" :loading="sendChargeWalletSmsLoading">
						ارسال لینک پرداخت
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { get } from 'vuex-pathify'

	export default {
		name: 'SmsCreditCharge',
		props: {
			data: { type: Object },
			area: { type: String, default: 'admin' },
		},
		data() {
			return {
				errorMessages: '',
				payable: 0,
				amount: 0,
				localData: {},
				submitLoading: false,
				sendChargeWalletSmsLoading: false,
				userCredit: 0
			}
		},
		computed: {
			...get('memberAppSettings', [
				'iceOnlinePaymentGateway'
			]),
			smsCredit() {
				return this.settings?.smsCredit || 0
			},
		},
		mounted() {
			this.amount = 100000
			this.loadUserCredit()
		},
		methods: {
			loadUserCredit() {
				api.get('member/User/loadUserCredit/' + (this.data?.id ? this.data?.id : ''), null)
					.then(
						response => {
							this.userCredit = response
						})
					.catch(err => {
					})
					.finally(x => {
					})
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.submitLoading = true
				let data = {
					amount: this.amount,
					memberPurchaseType: 1,
					paymentMethod: this.iceOnlinePaymentGateway
				}
				api.post('member/purchase/create', data)
					.then(response => {
						if (response.gateway === 'sep') {
							let form = document.getElementById('sepForm')
							let sepToken = document.getElementById('sepToken')
							sepToken.value = response.token
							form.submit()
						}
						else if (response.gateway === 'sepehr') {
							let form = document.getElementById('sepehrForm')
							let sepehrToken = document.getElementById('sepehrToken')
							sepehrToken.value = response.token
							let sepehrTerminal = document.getElementById('sepehrTerminalId')
							sepehrTerminal.value = response.terminalId
							form.submit()
						}
						else {
							window.location.replace(response.gatewayUrl)
						}
					})
					.catch(err => {
						this.submitLoading = false
						toast.error(err.message)
					})
			},
			sendChargeWalletSms() {
				this.sendChargeWalletSmsLoading = true
				api.post(`${this.area}/AppSms/SendWalletCharge/?id=` + this.data?.id + '&type=WalletChargeSmsPattern', null)
					.then(response => {
						toast.success('پیامک ارسال شد.')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.sendChargeWalletSmsLoading = false
					})
			},
		},
	}
</script>
<style></style>
